import React from 'react'
import { FormattedMessage } from 'react-intl'

import { InlineErrorBanner } from '../../../molecules/inlineErrorBanner/InlineErrorBanner'

/**
 * Error banner displayed when a DBT user selects "No, for a teen" option.
 * This is a blocking error - users cannot proceed with registration when seeking care for a teen.
 */
export const DbtTeenErrorBanner: React.FC = () => {
  return (
    <InlineErrorBanner
      text={
        <FormattedMessage
          defaultMessage='This service is currently unavailable for teens. For additional support, contact care@lyrahealth.com'
          description='Error state if user chooses “No, I’m searching for a teen dependent”'
        />
      }
      testId='DbtTeenErrorBanner'
    />
  )
}
